import { _, React, Component, Container, Icon } from 'utils';
import { ResumeStore, ActiveStore, Creators, Campaigns, QualificationStore, CreditStore } from 'model';
import Resume from './Resume';
import Pager from './Pager';
import CampaignSelector from './campaignselector';
import Page from './Pager';
import './resumes.less';
import PageCount from "./PageCount";

class Resumes extends Component {
	
	static getStores() {
		return [ResumeStore, Campaigns, QualificationStore, CreditStore];
	}

	static calculateState() {
		var state = ResumeStore.getState();
		var formatter = ResumeStore.getQualificationFormater();

		return {
			loading: state.loading,
			resumes: state.resumes,
			formatter: formatter,
			total: state.total,
			filters: ActiveStore.getState().filters,
			pages: ResumeStore.getPages(),
			selected: ResumeStore.getSelectedCount(),
			checked: ResumeStore.getSelectAllStatus(),
			credits: CreditStore.getState(),
			count: state.count,
		}
	}

	handleMove(toFolder) {
		var selectedResumes = ResumeStore.getSelected();
		Creators.move(selectedResumes, toFolder);
	}

	handlePageChange(page) {
		Creators.pageChanged(page);

		$('html, body').animate({
			scrollTop: 0
		}, 'slow');
	}

	handleCountChange(e) {
		Creators.countChanged(e.target.value);
	}

	handleResumeClick(e) {
		const { credits } = this.state;
		
        if (!credits.total || credits.total <= 0) {
            Creators.showNoCredits();
            e.preventDefault();
            return true;
        }

        return false;
	}

	handleSelectAll = () => {
		Creators.selectAll(this.checkbox.checked);
	}

	render() {
		var { resumes, total, formatter, filters, pages, selected, checked, loading, credits, count } = this.state;

		var msg = '';
		var nf = new Intl.NumberFormat('hr', {useGrouping: true });

		if(filters.length == 0) {
			msg = <span> { _('Pretraži') } <strong>{nf.format(total)}</strong> { _('životopisa') }</span>;
		} else if (resumes.length > 0) {
			msg = <span><strong>{ nf.format(total) }</strong> { _('životopisa odgovara unešenim kriterijima') }</span>;
		}

		if(loading == true) {
			msg = <span><i className="fa fa-hourglass-o msg"></i> { _('Učitavam') }</span>;
		}
		if(resumes.length > 0) {
			const resumeList = resumes.map(resume => (
				<Resume
					key={resume.id}
					model={resume}
					formatter={formatter}
					maxTitle={65}
					onClick={(e) => this.handleResumeClick(e)}
				/>
			));

			return <div className="resumes">
				<div className="total message">{ msg }</div>
				<div className="bulk-actions">
					<div className="row">
						<div className="col-sm-4 col-md-4">
							<CampaignSelector
								onSelect={ this.handleMove }
								className="btn btn-default"
							/>
						</div>

						<div className="col-sm-8 col-md-8 pager-box">
							<PageCount count={count} onClick={e => this.handleCountChange(e)} />
							<Pager pages={pages} onClick={this.handlePageChange} />
						</div>
					</div>
				</div>
				<div className="list-title">
					<input
						type="checkbox"
						checked={checked}
						ref={(checkbox) => {this.checkbox = checkbox; }}
						onClick={ this.handleSelectAll } />
					{ _('Označi sve')}
				</div>
				<div className="resumes-list">{resumeList}</div>
				<div className="bulk-actions">
					<div className="row">
						<div className="col-md-4">
							<CampaignSelector
								onSelect={ this.handleMove }
								className="btn btn-default"
							/>
						</div>
						<div className="col-sm-8 col-md-8 pager-box">
							<PageCount count={count} onClick={e => this.handleCountChange(e)} />
							<Pager pages={pages} onClick={this.handlePageChange} />
						</div>
					</div>
				</div>
			</div>;
		} else if(loading == true) {
			return <div className="no-filters message">{ msg }</div>;
		} else {
			return <div className="no-filters message">{ _('Nema rezultata') }</div>;
		}
	}
}

export default Container.create(Resumes);



// WEBPACK FOOTER //
// ./src/modules/app/resumes/Resumes.js